import { DEFAULT_TOAST_LIFE } from "../../../../common/EzToast";
import { RoleService } from "../../../../services";
import { goBack } from "../../../../utils/gotoback";
import { getMenuAccess } from "../../../../container/Login/login-utils";
import {
  TOAST,
  FETCH_ROLES_LIST,
  FETCH_ROLEINFO_INIT,
  FETCH_ROLE_DETAIL,
  UPDATE_ROLE,
  CREATE_ROLE,
  DELETE_ROLE,
  INIT_CREATE_ROLE_SCREEN,
  ROLE_SAVE_TABLE_STATE,
  FETCH_ROLE_MENU_ACCESS,
  FETCH_ALL_MENUS,
  SET_DELETE_CONFIRMATION_POPUP_VISIBILITY,
} from "../../../types/Systems/Role.type";

export const initializeRoleInfoScreen = () => ({ type: FETCH_ROLEINFO_INIT });

export const roleFetchStart = (payload) => ({
  type: FETCH_ROLES_LIST.START,
  payload,
});

export const roleFetchSuccess = (payload) => ({
  type: FETCH_ROLES_LIST.SUCCESS,
  payload,
});

export const roleFetchError = (payload) => ({
  type: FETCH_ROLES_LIST.ERROR,
  payload,
});

export const fetchRoles = (payload) => {
  return (dispatch) => {
    dispatch(roleFetchStart(payload));
    RoleService.fetchRoles(payload).then((roleData) => {
      if (!roleData.isError) {
        dispatch(roleFetchSuccess(roleData));
      } else {
        dispatch(roleFetchError(roleData));
      }
    });
  };
};

export const resetToast = (payload) => ({
  type: TOAST.RESET,
  payload,
});

export const roleDetailFetchStart = (payload) => ({
  type: FETCH_ROLE_DETAIL.START,
  payload,
});

export const roleDetailFetchSuccess = (payload) => ({
  type: FETCH_ROLE_DETAIL.SUCCESS,
  payload,
});

export const roleDetailFetchError = (payload) => ({
  type: FETCH_ROLE_DETAIL.ERROR,
  payload,
});

export const fetchRoleById = (payload) => {
  return (dispatch) => {
    dispatch(roleDetailFetchStart(payload));

    RoleService.fetchRoleById(payload).then((data) => {
      if (!data.isError) {
        dispatch(roleDetailFetchSuccess(data));
      } else {
        dispatch(roleDetailFetchError(data));
      }
    });
  };
};

// Fetch Role Menu Access
export const roleMenuAccessFetchStart = () => ({
  type: FETCH_ROLE_MENU_ACCESS.START,
});

export const roleMenuAccessFetchSuccess = (payload) => ({
  type: FETCH_ROLE_MENU_ACCESS.SUCCESS,
  payload,
});

export const roleMenuAccessFetchError = (payload) => ({
  type: FETCH_ROLE_MENU_ACCESS.ERROR,
  payload,
});

export const fetchRoleMenuAccess = (payload) => {
  return (dispatch) => {
    dispatch(roleMenuAccessFetchStart());
    RoleService.fetchRoleMenuAccess(payload).then((data) => {
      if (!data.isError) {
        dispatch(roleMenuAccessFetchSuccess(data));
      } else {
        dispatch(roleMenuAccessFetchError(data));
      }
    });
  };
};

// Fetch All Menus
export const allMenusFetchStart = () => ({
  type: FETCH_ALL_MENUS.START,
});

export const allMenusFetchSuccess = (payload) => ({
  type: FETCH_ALL_MENUS.SUCCESS,
  payload,
});

export const allMenusFetchError = (payload) => ({
  type: FETCH_ALL_MENUS.ERROR,
  payload,
});

export const fetchAllMenus = () => {
  return (dispatch) => {
    dispatch(allMenusFetchStart());
    RoleService.fetchAllMenus().then((data) => {
      if (!data.isError) {
        dispatch(allMenusFetchSuccess(data));
      } else {
        dispatch(allMenusFetchError(data));
      }
    });
  };
};

// Update role
export const updateRoleStart = () => ({
  type: UPDATE_ROLE.START,
});

export const updateRoleSuccess = (payload) => ({
  type: UPDATE_ROLE.SUCCESS,
  payload,
});

export const updateRoleError = (payload) => ({
  type: UPDATE_ROLE.ERROR,
  payload,
});

export const updateRole = (payload) => {
  return (dispatch) => {
    dispatch(updateRoleStart());
    RoleService.updateRole(payload).then(async (data) => {
      if (!data.isError) {
        dispatch(updateRoleSuccess());
        const token = localStorage.getItem("token");
        const userId = localStorage.getItem("userId");
        if (token && userId) {
          await getMenuAccess(token, userId);
        }
        goBack();
      } else {
        dispatch(updateRoleError(data));
      }
      setTimeout(() => {
        dispatch(resetToast());
      }, DEFAULT_TOAST_LIFE + 1000);
    });
  };
};

export const createRoleScreenInitStart = (payload) => ({
  type: INIT_CREATE_ROLE_SCREEN,
  payload,
});

export const initCreateRoleScreen = (payload) => {
  return (dispatch) => {
    dispatch(createRoleScreenInitStart(payload));
  };
};

export const createRoleStart = () => ({
  type: CREATE_ROLE.START,
});

export const createRoleSuccess = (payload) => ({
  type: CREATE_ROLE.SUCCESS,
  payload,
});

export const createRoleError = (payload) => ({
  type: CREATE_ROLE.ERROR,
  payload,
});

export const createRole = (payload) => {
  return (dispatch) => {
    dispatch(createRoleStart());
    RoleService.createRole(payload).then((data) => {
      if (!data.isError) {
        dispatch(createRoleSuccess(data));
        goBack();
      } else {
        dispatch(createRoleError(data));
      }

      setTimeout(() => {
        dispatch(resetToast());
      }, DEFAULT_TOAST_LIFE + 1000);
    });
  };
};

export const setDeleteConfirmationPopupVisibility = (payload) => ({
  type: SET_DELETE_CONFIRMATION_POPUP_VISIBILITY,
  payload,
});

// Delete Role
export const deleteRoleStart = (payload) => ({
  type: DELETE_ROLE.START,
  payload,
});

export const deleteRoleSuccess = (payload) => ({
  type: DELETE_ROLE.SUCCESS,
  payload,
});

export const deleteRoleError = (payload) => ({
  type: DELETE_ROLE.ERROR,
  payload,
});

export const deleteRole = (payload) => {
  return (dispatch) => {
    dispatch(deleteRoleStart());
    RoleService.deleteRole(payload?.id).then((data) => {
      if (!data.isError) {
        dispatch(deleteRoleSuccess());
        dispatch(fetchRoles({ sortField: 'id' }));
      } else {
        dispatch(deleteRoleError(data));
      }
      setTimeout(() => {
        dispatch(resetToast());
      }, DEFAULT_TOAST_LIFE + 1000);
    });
  };
};

/*----------------TABLE STATE PERSISTENCE----------------------------*/
export const saveRoleTableState = (payload) => ({
  type: ROLE_SAVE_TABLE_STATE,
  payload,
});
/*----------------END TABLE STATE PERSISTENCE----------------------------*/
